/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Meta_Count_DecksInputs */



/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{countFormatted} deck" |
* | * | "{countFormatted} decks" |
*
* @param {Meta_Count_DecksInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const meta_count_decks = /** @type {((inputs: Meta_Count_DecksInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Count_DecksInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") {
		const countPlural = registry.plural("de", i?.count, {}, true);
		const countFormatted = registry.number("de", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${countFormatted} Deck`);
		return /** @type {LocalizedString} */ (`${countFormatted} Decks`)
	}
	if (locale === "fr") {
		const countPlural = registry.plural("fr", i?.count, {}, true);
		const countFormatted = registry.number("fr", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${countFormatted} deck`);
		return /** @type {LocalizedString} */ (`${countFormatted} decks`)
	}
	if (locale === "zh-Hans") {
		const countPlural = registry.plural("zh-Hans", i?.count, {}, true);
		const countFormatted = registry.number("zh-Hans", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${countFormatted}副卡组`);
		return /** @type {LocalizedString} */ (`${countFormatted}副卡组`)
	}
	if (locale === "zh-Hant") {
		const countPlural = registry.plural("zh-Hant", i?.count, {}, true);
		const countFormatted = registry.number("zh-Hant", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${countFormatted} 副牌組`);
		return /** @type {LocalizedString} */ (`${countFormatted} 副牌組`)
	}
	if (locale === "ko") {
		const countPlural = registry.plural("ko", i?.count, {}, true);
		const countFormatted = registry.number("ko", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`덱 ${countFormatted}개`);
		return /** @type {LocalizedString} */ (`덱 ${countFormatted}개`)
	}
	{
		const countPlural = registry.plural("en", i?.count, {}, true);
		const countFormatted = registry.number("en", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${countFormatted} deck`);
		return /** @type {LocalizedString} */ (`${countFormatted} decks`)
	}
});